// extracted by mini-css-extract-plugin
export default {"page":"Resume_page__8F1Cp","error":"Resume_error__Z-zg1"};